export const serviceOptions = (key, options = []) => {
  switch (key) {
    case 'CHANNEL_BUY':
      return options?.map((el) => ({
        label: el.channelBuyNameTh,
        value: el.channelBuyId,
        channelBuyType: el.channelBuyType,
      }));
    case 'MOBILE_BRAND':
      return options?.map((el) => ({
        label: el.mobileBrandNameTh,
        value: el.mobileBrandId,
        mobileModels: el.mobileModels,
      }));
    case 'MOBILE_MODEL':
      return options?.map((el) => ({
        label: el.mobileModelNameTh,
        value: el.mobileModelId,
        products: el.products,
      }));
    case 'PRODUCT':
      return options?.map((el) => ({
        label: el.productDescriptionTh,
        value: el.mapProductId,
        productFullName: el.productFullName,
        productImageUrl: el.productImageUrl,
      }));
    case 'CHANNEL_CLAIM':
      return options?.map((el) => ({
        label: el.channelClaimNameLineOa,
        value: el.channelClaimId,
        channelClaimCode: el.channelClaimCode,
      }));
    case 'STORE_NAME':
      return options?.map((el) => ({
        label: el.storeName,
        value: el.storeId,
      }));
    case 'REASON_CHANGE_BOOKING_DATE':
      return options?.map((el) => ({
        label: el.optionStatusNameTh,
        value: el.optionStatusCode,
      }));
  }
};
